import { render } from "./VideoControls.vue?vue&type=template&id=f863047c&scoped=true"
import script from "./VideoControls.vue?vue&type=script&lang=js"
export * from "./VideoControls.vue?vue&type=script&lang=js"

import "./VideoControls.vue?vue&type=style&index=0&id=f863047c&scoped=true&lang=css"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f863047c"]])

export default __exports__